import { Form, Formik } from "formik"
import * as React from "react"

import Alert from "../../../design-system/alert"
import { EmailField, FirstNameField, LastNameField } from "../../form"
import SubmitButton from "../../form/submit-button"
import { trackSubmission } from "./helpers"
import * as styles from "./index.module.scss"
import { FormValues, getInitialValues } from "./types"
import { useForm } from "./use-form"

const LegalDisbursementsForm = () => {
  const { globalError, onSubmit } = useForm()
  return (
    <div className={styles.formContainer}>
      {globalError && <Alert variant="error" text={globalError} />}
      <Formik<FormValues>
        initialValues={getInitialValues()}
        onSubmit={onSubmit}
      >
        <Form data-testid="legal-disbursements-demo-form">
          <EmailField />
          <FirstNameField />
          <LastNameField />
          <div className={styles.button}>
            <SubmitButton<FormValues> onError={trackSubmission} />
          </div>
        </Form>
      </Formik>
    </div>
  )
}

export default LegalDisbursementsForm
